export const API_URL = "https://raidenlabs-backend-dev-dvgjcaftddhygddm.eastus-01.azurewebsites.net";
